import { render, staticRenderFns } from "./JianKang_DataCenter.vue?vue&type=template&id=649f001a&scoped=true"
import script from "./JianKang_DataCenter.vue?vue&type=script&lang=js"
export * from "./JianKang_DataCenter.vue?vue&type=script&lang=js"
import style0 from "./JianKang_DataCenter.vue?vue&type=style&index=0&id=649f001a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649f001a",
  null
  
)

export default component.exports